import type React from "react";

export type IconSize = 12 | 16 | 20 | 24 | 32 | 48 | 64;
export type IconVariant = "Line" | "Solid" | "Color";

export interface IconoirIconProps extends Omit<
  React.SVGProps<SVGSVGElement>,
  "width" | "height"
> {
  className?: string;
}

// Stroke weights mapped by size (from design specs)
export const STROKE_WEIGHTS: Record<IconSize, number> = {
  12: 2,
  16: 2.25,
  20: 1.8,
  24: 1.5,
  32: 1.5,
  48: 1,
  64: 0.75,
};

// Tailwind size classes for each pixel size
export const SIZE_CLASSES: Record<IconSize, string> = {
  12: "size-3", // 12px = 0.75rem
  16: "size-4", // 16px = 1rem
  20: "size-5", // 20px = 1.25rem
  24: "size-6", // 24px = 1.5rem
  32: "size-8", // 32px = 2rem
  48: "size-12", // 48px = 3rem
  64: "size-16", // 64px = 4rem
};
